function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import includes from 'lodash/includes';
import * as constants from './constants';
import classNames from 'classnames'; // TextInput component can render some components inside the form input, such as icons.

export var isIconComponent = function isIconComponent(_ref) {
  var type = _ref.type;
  return includes(constants.CHILD_COMPONENT_WHITELIST, type);
};
export var getButtonClassNames = function getButtonClassNames(_ref2) {
  var _classNames;

  var type = _ref2.type,
      style = _ref2.style,
      size = _ref2.size,
      isFollowing = _ref2.isFollowing,
      isLoading = _ref2.isLoading,
      isSuccessful = _ref2.isSuccessful,
      isNotSuccessful = _ref2.isNotSuccessful,
      disabled = _ref2.disabled,
      phab = _ref2.phab,
      hasIconsOnly = _ref2.hasIconsOnly,
      hasIconsAndOtherChildren = _ref2.hasIconsAndOtherChildren,
      __containerClassName = _ref2.__containerClassName;
  var className = classNames((_classNames = {
    'eds-btn': !includes([constants.STYLE_ANCHOR, constants.STYLE_NONE], style)
  }, _defineProperty(_classNames, "eds-btn--".concat(type), type), _defineProperty(_classNames, "eds-btn--".concat(style), style), _defineProperty(_classNames, "eds-btn--".concat(size), size), _defineProperty(_classNames, 'eds-btn--following', isFollowing), _defineProperty(_classNames, 'eds-btn--loading', isLoading), _defineProperty(_classNames, 'eds-btn--successful', isSuccessful), _defineProperty(_classNames, 'eds-btn--not-successful', isNotSuccessful), _defineProperty(_classNames, 'eds-btn--disabled', disabled && !isLoading), _defineProperty(_classNames, 'eds-btn--phab', phab), _defineProperty(_classNames, 'eds-link', style === constants.STYLE_ANCHOR), _defineProperty(_classNames, 'eds-btn--icon-only', hasIconsOnly), _defineProperty(_classNames, 'eds-btn--icon-with-other-children', hasIconsAndOtherChildren), _classNames), __containerClassName);
  return className;
};